import { IUpdateEntradaMultiPUseCase } from "../../../presentation/useCases/update/update_entrada_produtos_multi_use_case";
import { EntradaProduto } from "../../models/entrada_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class UpdateEntradaMultiPUseCase implements IUpdateEntradaMultiPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async updateEntradaMultiP(EntradaProduto: EntradaProduto[]): Promise<void> {
    
    await this.repository.updateEntradaMultiP(EntradaProduto);
  }
}
